import EditablePropsType from '../../../types/composer';
import headingSchema from '../../../lib/composer/schemas/heading';
import subheadingSchema from '../../../lib/composer/schemas/subheading';
import textSchema from '../../../lib/composer/schemas/text';
import themeSchema from '../../../lib/composer/schemas/theme';

/**
 * Generates the fields for the Plan Selector block in the composer.
 * @param {string} [suffix=''] - Optional suffix to append to field names.
 * @returns {Array} Array of field definitions for the Plan Selector block.
 */
export function getPlanSelectorFields(suffix = '') {
  return [
    {
      label: `Select program/product ${suffix ? ' ' + suffix : ''}`,
      name: `productID${suffix}`,
      type: EditablePropsType.ProductWithProgram,
      description: `If not using the package-selector, deselect program/product 2`,
      defaultValue: '', // Empty string for product ID (Program Default)
      required: true,
    },
    {
      label: `Plan Version${suffix ? ' ' + suffix : ''}`,
      name: `planVersion${suffix}`,
      type: EditablePropsType.Text,
      defaultValue: '',
    },
    {
      label: `Plan Lengths${suffix ? ': set ' + suffix : ''}`,
      name: `planLengths${suffix}`,
      description:
        'Plan lengths to display in months. Defaults to 6, 12, 24 - if they all exist.',
      type: EditablePropsType.Array,
      items: {
        type: EditablePropsType.Text,
        name: `planLength${suffix}`,
        label: `Plan Length${suffix ? ': set ' + suffix : ''}`,
        required: true,
      },
    },
  ];
}

export const sharedPlanSelectorFields = [
  ...getPlanSelectorFields(),
  headingSchema,
  subheadingSchema,
  textSchema,
  themeSchema,
];

// Per-length deal codes are configured on the deal in Admin (Store > Deals),
// not in Composer - see components/composer/README.md.

export const discountPillsSchema = {
  label: 'Discount pills by plan length',
  name: 'discountPills',
  description:
    'Optionally customize the discount pill for each plan length. Use {amount} to insert the calculated savings percentage.',
  type: EditablePropsType.Array,
  items: {
    label: 'Discount pill',
    name: 'discountPill',
    type: EditablePropsType.Object,
    properties: {
      planLength: {
        label: 'Plan length in months',
        name: 'planLength',
        type: EditablePropsType.Text,
        required: true,
      },
      text: {
        label: 'Pill text',
        name: 'text',
        type: EditablePropsType.Text,
        required: true,
      },
    },
  },
};
